import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestJustificativaAlteracaoEncerrantes({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'justificativaalteracaoencerrantes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteJustificativaAlteracaoEncerrante({ payload }) {
  try {
    const { idjustificativaalteracaoencerrante, params } = payload;

    yield call(
      api.delete,
      `justificativaalteracaoencerrantes/${idjustificativaalteracaoencerrante}`
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { justificativaalteracaoencerrante, params } = payload;

    yield call(
      api.post,
      'justificativaalteracaoencerrantes',
      justificativaalteracaoencerrante
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operjustalteracaoencerrante');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idjustificativaalteracaoencerrante } = payload;

    const { data } = yield call(
      api.get,
      `justificativaalteracaoencerrantes/${idjustificativaalteracaoencerrante}`
    );
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { justificativaalteracaoencerrante, params } = payload;

    yield call(
      api.put,
      'justificativaalteracaoencerrantes',
      justificativaalteracaoencerrante
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operjustalteracaoencerrante');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'justificativaalteracaoencerrantes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@justificativaalteracaoencerrantes/JUSTIFICATIVAALTERACAOENCERRANTES_IN_REQUEST',
    requestJustificativaAlteracaoEncerrantes
  ),
  takeLatest(
    '@justificativaalteracaoencerrantes/DELETE_JUSTIFICATIVAALTERACAOENCERRANTE',
    deleteJustificativaAlteracaoEncerrante
  ),
  takeLatest(
    '@justificativaalteracaoencerrantes/SUCCESS_REMOVE',
    requestJustificativaAlteracaoEncerrantes
  ),
  takeLatest(
    '@justificativaalteracaoencerrantes/STORE_JUSTIFICATIVAALTERACAOENCERRANTE',
    store
  ),
  takeLatest(
    '@justificativaalteracaoencerrantes/FIND_JUSTIFICATIVAALTERACAOENCERRANTE',
    find
  ),
  takeLatest(
    '@justificativaalteracaoencerrantes/UPDATE_JUSTIFICATIVAALTERACAOENCERRANTE',
    update
  ),
  takeLatest(
    '@justificativaalteracaoencerrantes/RECORD_FILTERING',
    applyedFilters
  ),
]);
